/* eslint-disable no-useless-catch */
import {
  customerById,
  priceReasons,
  registerCustomer,
  restorePassword,
  updateCustomer,
} from 'api/core'
import {
  addressByGeolocation,
  addressCountedCustomer,
  listCountries,
  listCustomers,
  allStadistics,
  listWharehouse,
  customerByIdAccountDetail,
  deleteCustomer,
  districtByProvince,
  listCustomerGroup,
  listDocumentTypes,
  listNationalities,
  listTelephoneTypes,
  provincesByCountry,
  searchBranchInfoByBranchId,
  searchCustomers,
  searchInfoAddressId,
  townshipByDistrict,
  updateAddress,
  updateAddressCountedCustomer,
} from 'api/mdl03'
import {
  deleteListPrices,
  listBranches,
  listPrices,
  listPricesByCustomer,
  saveListPrices,
} from 'api/mdl04'
import { priceListByCustomerId } from 'api/mdl22'
import { paintingHistoryByCustomerId } from 'api/mdl11'
import { getFinalPriceService } from 'redux/services/clientsServices'

export const fetchCustomerById =
  (id, mdl03 = false, params) =>
  async () => {
    try {
      const response = await (mdl03
        ? params
          ? customerByIdAccountDetail(id, true, params)
          : customerByIdAccountDetail(id)
        : customerById(id))
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      }
    } catch (err) {
      throw err
    }
  }

export const fetchListWharehouse = payload => async () => {
  try {
    const response = await listWharehouse(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    throw err
  }
}

export const fetchSearchCustomers = payload => async () => {
  try {
    const response = await searchCustomers(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    throw err
  }
}

export const fetchAddressCountedCustomer =
  ({ payload, type }) =>
  async () => {
    const service =
      type === 'update'
        ? updateAddressCountedCustomer(payload)
        : addressCountedCustomer(payload)

    try {
      const response = await service
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      }
    } catch (err) {
      throw err
    }
  }

export const fetchSearchInfoAddressId = id => async () => {
  try {
    const response = await searchInfoAddressId(id)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    throw err
  }
}

export const fetchDeleteCustomer = payload => async () => {
  try {
    const response = await deleteCustomer(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    throw err
  }
}

export const fetchSearchBranchInfoByBranchId = id => async () => {
  try {
    const response = await searchBranchInfoByBranchId(id)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    throw err
  }
}

export const fetchPriceListByCustomerId = customerId => async () => {
  try {
    const response = await priceListByCustomerId(customerId)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchListPrices = payload => async () => {
  try {
    const response = await listPrices(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchSaveListPrices = payload => async () => {
  try {
    const response = await saveListPrices(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchDeleteListPrices = payload => async () => {
  try {
    const response = await deleteListPrices(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchListPricesByCustomer = payload => async () => {
  try {
    const response = await listPricesByCustomer(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchRegisterCustomer = payload => async () => {
  try {
    const response = await registerCustomer(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchUpdateCustomer = payload => async () => {
  try {
    const response = await updateCustomer(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return response
    } else {
      return data.Status
    }
  } catch (err) {
    throw err
  }
}

export const fetchUpdateAddress = payload => async () => {
  try {
    const response = await updateAddress(payload)
    const { data, status } = response
    const Status = data?.Status

    if (status === 200 && data?.Data) {
      return data.Data
    }
    if (Status?.Code === 406) {
      return Status
    } else {
      return 'Error: ' + data.Status
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchAddressByGeolocation = payload => async () => {
  try {
    const response = await addressByGeolocation(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + data.Status
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchProvincesByCountryAction = payload => async () => {
  try {
    const response = await provincesByCountry(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + data.Status
    }
  } catch (err) {
    return 'Error: ' + err
  }
}
export const fetchDistrictByProvince = payload => async () => {
  try {
    const response = await districtByProvince(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + data.Status
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchTownshipByDistrict = payload => async () => {
  try {
    const response = await townshipByDistrict(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + data.Status
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchListBranches = payload => async () => {
  try {
    const response = await listBranches(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const getFinalPriceAction = payload => async () => {
  try {
    const response = await getFinalPriceService(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    // throw err;
    return 'Error: ' + err
  }
}

export const fetchPriceReasons = payload => async () => {
  try {
    const response = await priceReasons(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchListCustomers = payload => async () => {
  try {
    const response = await listCustomers(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchAllStadistics = payload => async () => {
  try {
    const response = await allStadistics(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchListCountries = () => async () => {
  try {
    const response = await listCountries()
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}
export const fetchListTelephoneTypes = () => async () => {
  try {
    const response = await listTelephoneTypes()
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}
export const fetchListCustomerGroup = payload => async () => {
  try {
    const response = await listCustomerGroup(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchListDocumentTypes = payload => async () => {
  try {
    const response = await listDocumentTypes(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchListNationalities = async () => {
  try {
    const response = await listNationalities()

    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    return 'Error: ' + err
  }
}

export const fetchRestorePassword = payload => async () => {
  try {
    const response = await restorePassword(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return response.data.Status.Message
    }
  } catch (err) {
    return err
  }
}

export const fetchPaintingHistoryByCustomerId = payload => async () => {
  try {
    const response = await paintingHistoryByCustomerId(payload)
    const { data, status } = response

    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return data.Data
    }
  } catch (err) {
    return err
  }
}
